<div class="marquee-wrapper">
    <div class="marquee-container" #container>
        <div class="marquee" [class.paused]="!(playToggle$ | async)" #content>
          <ng-content></ng-content>
        </div>
      </div>
</div>